import React from "react";
import LoadingWhite from "../assets/loading/laoding-white.svg";
import Loading from "../assets/loading/laoding.svg";

export default function LoadingPage() {
  return (
    <div className="w-full flex justify-center items-center login_background min-h-screen">
      <div className=" absolute top-0 left-0 w-full flex items-center justify-center h-screen">
        <img
          src={LoadingWhite}
          alt=""
          className="w-full items-center justify-center h-12"
        />
      </div>
      <div className="w-7/12 login_stroke border-2 border-violet rounded-xl py-12 px-20 mt-8 blur-sm opacity-60">
        <h1 className="font-bold text-5xl text-white mb-2">Redirecting ...</h1>
        <p className="text-white-100 mb-4">
          Welcome to the dashboard. with this you can access to bio data and
          etc.
        </p>
        <form className="flex flex-col justify-center items-center">
          <input
            className="w-full rounded-lg px-2 my-2 h-10 border border-violet bg-transparent text-white"
            type="text"
            placeholder="Email"
          />
          <input
            className="w-full rounded-lg px-2 my-2 h-10 border border-violet bg-transparent text-white"
            type="password"
            placeholder="Password"
          />
          <div className="flex flex-col w-6/12 mt-2 items-center justify-center">
            <button
              className="w-full bg-blue-dark hover:bg-violet text-white rounded-lg h-10 mt-4 my-1"
              type="submit"
            >
              Redirecting...
            </button>
            <p className="text-white">
              Don't have an account? <div className="text-yellow">Sign Up</div>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
